import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';

import { isForeignNumber } from '~/features/whatsapp/utils/resolveChatNumberStatus';

type Chat = SchemaChatResolver_GetChats[number];
type PresentNumberBannerCandidate = { chat: Chat; senderUnavailable: boolean };
type NumberBannerCandidate = { chat: Chat | undefined; senderUnavailable: boolean };

// One banner for the combined view: a dead sender number outranks a chat on another number.
export const resolveCombinedNumberBanner = ({
    candidates,
    ownPhoneNumberId,
}: {
    candidates: Array<NumberBannerCandidate>;
    ownPhoneNumberId: string | null | undefined;
}): PresentNumberBannerCandidate | null => {
    const present = candidates.filter((candidate): candidate is PresentNumberBannerCandidate =>
        Boolean(candidate.chat),
    );
    return (
        present.find((candidate) => candidate.senderUnavailable) ??
        present.find(({ chat }) => isForeignNumber(chat.phoneNumberId, ownPhoneNumberId)) ??
        null
    );
};
